import List from 'apollo-react/components/List';
import ListItem from 'apollo-react/components/ListItem';
import ListItemText from 'apollo-react/components/ListItemText';
import Popover from 'apollo-react/components/Popover';
import React from 'react';

import Loader from '../CustomLoader';

function LookupPopover({ values = [], onSelect, showLoader, ...popoverProps }) {
  const showLookupValues = !showLoader && values.length > 0;
  const paperStyle = showLookupValues ? {} : { padding: 50 };
  const PaperProps = {
    style: paperStyle,
  };
  const lookupValues = showLookupValues ? (
    <List>
      {values.map((v, index) => (
        <ListItem key={index} onClick={() => onSelect(v)} button>
          <ListItemText primary={v} />
        </ListItem>
      ))}
    </List>
  ) : (
    'No lookup values.'
  );

  return (
    <Popover {...popoverProps} PaperProps={PaperProps} disableEnforceFocus>
      {showLoader ? <Loader /> : lookupValues}
    </Popover>
  );
}

export default LookupPopover;
